import React, { useState } from "react";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import { Store } from "react-notifications-component";
import Validation from "./LoginValidation";
import './Login.css';

export default function Login() {
  const navigate = useNavigate();
  const notification = {
    // message: "teodosii@react-notifications-component",
    insert: "top",
    container: "bottom-center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 2000,
      showIcon: true,
      onScreen: true,
    },
  };

  const [Data, setData] = useState({
    password: "",
    number: "",
  });

  const handleChange = (e) => {
    setData({ ...Data, [e.target.name]: e.target.value });
  };

  const [error, setError] = useState({});

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(Validation(Data));

    let fdata = new FormData();
    fdata.append("number", Data.number);
    fdata.append("password", Data.password);
    if (Data.number && Data.password) {
      axios
        .post(
          "https://vipin.hyperofficial.in/Master/api/settingapi/login",
          fdata
        )
        .then((response) => {
          // console.log(response);
          if (response.data.status === "1") {
            Store.addNotification({
              ...notification,
              title: response.data.msg,
              type: "success",
            });
            // console.log(response.data.LoginData.userid);
            window.localStorage.setItem(
              "userid",
              response.data.LoginData.userid
            );
            navigate("/");
          }
          if (response.data.status === "0") {
            Store.addNotification({
              ...notification,
              title: response.data.msg,
              type: "danger",
            });
          }
        })
        .catch((error) => {
          alert(error);
        });
    }
  };

  return (
    <>
      <section className="login-section section_padding_top bgc-home20">
      <div className="login-form default-form login_page_form">
          <div className="form-inner">
            <h3>Login to Yourdoostep</h3>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Mobile Number : </label>
                <input
                  className="form-controll"
                  type="number"
                  name="number"
                  value={Data.number}
                  onChange={handleChange}
                  placeholder="Enter Mobile Number"
                />
                {error.number && (
                  <span className="text-danger">* {error.number}</span>
                )}
              </div>

              <div className="form-group">
                <label>Password : </label>
                <input
                  id="password-field"
                  type="password"
                  name="password"
                  value={Data.password}
                  onChange={handleChange}
                  placeholder="Enter Unique Password"
                />
                {error.password && (
                  <span className="text-danger">* {error.password}</span>
                )}
              </div>
              <div className="form-group">
                <button className="theme-btn btn-style-one" type="submit"
                  name="submit">Log In</button>
              </div>
            </form>

            <div className="bottom-box">
              <div className="text">
                Don't have an account ? <NavLink to="/register">Signup</NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
